import { countRecaneGroups } from '../../shipping/utils/countRecaneGroups';
import { useShipmentContext } from '../hooks/useShipmentContext';

export const RecaneBanner = ({
  recaneEmbryoCount,
}: {
  recaneEmbryoCount?: number;
}) => {
  const { shipment } = useShipmentContext();
  const count = recaneEmbryoCount ?? countRecaneGroups(shipment.recaneEmbryos);

  if (count === 0) {
    return null;
  }
  return (
    <div className="mb-1 flex w-full items-center gap-2 rounded border border-purple-200 bg-purple-50 px-3 py-1.5">
      <i className="pi pi-exclamation-circle text-purple-600" />
      <span className="text-sm text-purple-900">
        {count} {count === 1 ? 'recane' : 'recanes'} required
      </span>
    </div>
  );
};
